export const listingManager = {
  header: {
    title: "الإعلانات",
    newListingTitle: "إعلان جديد",
    reorderExit: "الخروج من وضع إعادة الترتيب",
    reorder: "إعادة ترتيب الإعلانات",
    done: "تم",
    sort: "ترتيب",
    searchPlaceholder: "بحث…",
    searchClear: "مسح",
    reorderHint: "اسحب لتغيير الترتيب",
  },
  globalBtn: {
    title: "الإعدادات العامة",
    sub: "الهوية والحجوزات الجديدة · الحساب بالكامل",
  },
  list: {
    of: "من",
    listingSingular: "إعلان",
    listingPlural: "إعلانات",
    unitSingular: "وحدة",
    unitPlural: "وحدات",
    retry: "إعادة المحاولة",
    noResults: 'لا توجد نتائج لـ "{query}"',
    viewUnits: "عرض الوحدات",
    loadingUnits: "جارٍ تحميل الوحدات…",
    refuerzaA: "يدعم {name}: يستقبل حالياً حجوزاته القادمة من القناة",
    noUnits: "لا توجد وحدات",
    dragToMove: "اسحب للنقل",
    unitFallback: "وحدة {n}",
  },
  empty: {
    title: "اختر إعلانًا",
    sub: "اختر إعلانًا من اللوحة اليسرى لإدارة إعداداته.",
  },
  create: {
    title: "إعلان جديد",
    subtitle: "أنشئ إعلانًا لتجميع وحداتك.",
    nameLabel: "اسم الإعلان",
    namePlaceholder: "مثال: بوابة الشمس",
    typeLabel: "نوع الإقامة",
    currencyLabel: "العملة",
    currencyHint: "لا يمكن تغيير العملة بعد إنشاء الإعلان.",
    submit: "إنشاء إعلان",
    nameRequired: "الاسم مطلوب.",
    errorCreate: "حدث خطأ أثناء إنشاء الإعلان.",
    successCreate: "تم إنشاء الإعلان بنجاح.",
  },
  delete: {
    titleListing: "حذف الإعلان",
    titleUnit: "حذف الوحدة",
    text: "سيتم حذفه من WACheckin. لا يمكن التراجع عن هذه التغييرات. للتأكيد، اكتب الاسم:",
    placeholderListing: "اسم الإعلان",
    placeholderUnit: "اسم الوحدة",
    deleting: "جارٍ الحذف…",
    confirm: "حذف",
    errorDelete: "تعذّر الحذف.",
    successListing: "تم حذف الإعلان بنجاح.",
    successUnit: "تم حذف الوحدة بنجاح.",
  },
  propertyTypes: {
    apartment: "شقة",
    villa: "فيلا",
    hotel: "فندق",
    camping: "تخييم",
  },
  propertyTypeLabels: {
    apartment: "شقة",
    house: "منزل",
    villa: "فيلا",
    hotel: "فندق",
    room: "غرفة",
    studio: "استوديو",
    fallback: "إقامة",
  },
  toast: {
    errorLoad: "حدث خطأ أثناء تحميل الإعلانات.",
    orderSaved: "تم حفظ الترتيب بنجاح.",
    errorOrder: "تعذّر حفظ الترتيب.",
    nameUpdated: "تم تحديث الاسم.",
    errorName: "تعذّر تحديث الاسم.",
  },
  common: {
    cancel: "إلغاء",
  },
  globalConfig: {
    hero: {
      title: "الإعدادات العامة",
      subPre: "إعدادات وكيل الذكاء الاصطناعي التي تنطبق على",
      subStrong: "جميع أماكن إقامتك",
      subPost: ".",
    },
    waba: {
      checking: "جارٍ التحقق من الاتصال…",
      connected: "متصل",
      start: "ابدأ من هنا",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "ربط WhatsApp Business",
      checkingSub: "جارٍ التحقق من حالة رقمك…",
      numberPrefix: "الرقم",
      verified: "مُوثَّق وجاهز للإرسال ✓",
      pending: "في انتظار التوثيق",
      linked: "تم ربط حساب WhatsApp Business الخاص بك.",
      linkPrompt: "اربط رقمك ليتمكن الوكيل من الرد على ضيوفك وإرسال الرسائل إليهم عبر WhatsApp.",
      manage: "إدارة",
      connect: "ربط",
    },
    sectionLabel: "عام · الحساب بالكامل",
    badgeDefault: "ذكاء اصطناعي ✨",
    requiresWaba: "يتطلب ربط WhatsApp Business",
    notContracted: "غير مُضمَّن في باقتك. تواصل معنا لتفعيله.",
    cards: {
      general: {
        title: "الإعدادات العامة",
        sub: "هوية الوكيل وأسلوبه",
      },
      newBookings: {
        title: "الحجوزات الجديدة",
        sub: "التواصل الأول والاستفسارات ورابط الحجز",
      },
      voiceAgent: {
        title: "وكيل الذكاء الاصطناعي الصوتي",
        sub: "يرد على المكالمات الهاتفية",
        badge: "جديد",
      },
    },
    foot: {
      pre: "هذه الإعدادات",
      strong: "خاصة بحسابك",
      post: ": عند تغييرها هنا، تُطبَّق تلقائيًا على جميع الإعلانات. أما بقية الإعدادات (تسجيل الوصول، عمليات الدخول، الأسعار…) فتبقى خاصة بكل إعلان.",
    },
  },
};
